import { __awaiter, __extends, __generator } from "tslib";
import { SdkMessageTypes } from '../constants';
import { validLegacyLinkOrigin } from '../utils/helpers';
import { BaseMessageHandler } from './base-message-handler';
import { formulateAppMessageResult, onStatusError } from './messageHandlingUtils';
/**
 * Responsible for calender module related message requests.
 */
var CalendarMessageHandler = /** @class */ (function (_super) {
    __extends(CalendarMessageHandler, _super);
    function CalendarMessageHandler(appSdkHost, calendarService, telemetryService) {
        var _this = _super.call(this, appSdkHost, telemetryService) || this;
        _this.calendarService = calendarService;
        return _this;
    }
    CalendarMessageHandler.prototype.initHandlers = function () {
        var _this = this;
        this.registerHandler(SdkMessageTypes.calendar.openCalendarItem, function (_, params) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.calendarService.openCalendarItem(params)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, formulateAppMessageResult([true])];
                }
            });
        }); }, {
            errorCallback: function (error, scenario) { return onStatusError(SdkMessageTypes.calendar.openCalendarItem, error, scenario); },
        });
        this.registerHandler(SdkMessageTypes.calendar.composeMeeting, function (_, params) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.calendarService.composeMeeting(params)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, formulateAppMessageResult([true])];
                }
            });
        }); }, {
            errorCallback: function (error, scenario) { return onStatusError(SdkMessageTypes.calendar.composeMeeting, error, scenario); },
        });
    };
    CalendarMessageHandler.prototype.validateDependencies = function () {
        if (!this.calendarService) {
            throw 'No calendarService provided';
        }
    };
    return CalendarMessageHandler;
}(BaseMessageHandler));
export { CalendarMessageHandler };
var CalendarLegacyLinkHandler = /** @class */ (function () {
    function CalendarLegacyLinkHandler(calendarService) {
        this.calendarService = calendarService;
    }
    CalendarLegacyLinkHandler.prototype.tryGetDataFromLink = function (url) {
        var _a;
        if (!this.calendarService) {
            return null;
        }
        if (url.origin != validLegacyLinkOrigin || url.pathname != '/l/meeting/new') {
            return null;
        }
        var attendees = (_a = url.searchParams.get('attendees')) === null || _a === void 0 ? void 0 : _a.split(',');
        var startTime = url.searchParams.get('startTime') || undefined;
        var endTime = url.searchParams.get('endTime') || undefined;
        var subject = url.searchParams.get('subject') || undefined;
        var content = url.searchParams.get('content') || undefined;
        return {
            attendees: attendees,
            startTime: startTime,
            endTime: endTime,
            subject: subject,
            content: content,
        };
    };
    CalendarLegacyLinkHandler.prototype.executeData = function (data) {
        return this.calendarService.composeMeeting(data);
    };
    return CalendarLegacyLinkHandler;
}());
export { CalendarLegacyLinkHandler };
//# sourceMappingURL=calendar-message-handler.js.map